import React, {useEffect} from 'react'
import './blogOverviewPage.css'
import {blogData} from "../../Data"
import {Link} from "react-router-dom"
import {RxDoubleArrowRight} from "react-icons/rx"
import Aos from "aos"
import 'aos/dist/aos.css'

const BlogOverviewPage = () => {
    useEffect(() => {
        Aos.init({duration:1500})
    }, [])

    return (
        <>
            <section id='blog_overview_page'>
                <div className="blog_overview_header">
                    <p className="eyebrow">Journal</p>
                    <h1>Notes on design & visualisation</h1>
                    <p>Practical thoughts on architectural sketching, creative process and presenting design ideas clearly.</p>
                </div>
                <div className='container blog_overview_page_container'>
                    {
                        blogData.map((blog, index) => {
                            return (
                                <article data-aos='zoom-in' data-aos-duration='2000' key={index} className='overview_page_item'>
                                    <div className="overview_image_wrap"><img className='blog_img' src={blog.img} alt={blog.title} loading="lazy" decoding="async"/></div>
                                    <div className="overview_content">
                                        <span className="article_meta">Article · {blog.datePublished}</span>
                                        <div className="title"><h2>{blog.title}</h2></div>
                                        <p className="article_excerpt">{blog.description}</p>
                                        <Link to={blog.path} className='blog_link'>Read more&nbsp;
                                            <RxDoubleArrowRight className='icon'/>
                                        </Link>
                                    </div>
                                </article>
                            )
                        })
                    }
                </div>
            </section>
        </>
    )
}

export default BlogOverviewPage
